import 'slick-carousel/slick/slick'

export default class CaseStudiesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-image-gallery')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $('.js-gallery-previous'),
                nextArrow: $('.js-gallery-next'),
                appendDots: $('.js-gallery-dots'),
            });
        }

    }

};

new CaseStudiesSlider();